import { Link } from 'react-router-dom';
import { categoryComics, editorPickImages } from '@/mocks/category';
import { categoryInfo } from '@/mocks/category';

interface EditorPicksProps {
  slug: string;
}

const defaultPickImage = 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20editor%20pick%20wide%20banner%2C%20epic%20composition%2C%20Korean%20webtoon%20style%2C%20warm%20dramatic%20lighting&width=500&height=313&seq=ep-default-pick&orientation=landscape';

export default function EditorPicks({ slug }: EditorPicksProps) {
  const categoryName = categoryInfo[slug]?.name || '精选';
  const picks = categoryComics.filter((c) => c.category === slug).slice(0, 5);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            编辑精选 · {categoryName}
          </h2>
          <p className="text-foreground-500 text-sm">编辑团队为你精心挑选的必读佳作</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {picks.map((comic, idx) => {
            const isFirst = idx === 0;
            return (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className={`relative group overflow-hidden rounded-lg cursor-pointer ${
                  isFirst ? 'sm:col-span-2 sm:row-span-2' : ''
                }`}
                style={{ aspectRatio: isFirst ? '16/10' : '3/4' }}
              >
                <img
                  src={editorPickImages[comic.id] || defaultPickImage}
                  alt={comic.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-medium">
                      {comic.rating}
                    </span>
                    <span className="text-white/60 text-xs">{comic.status}</span>
                  </div>
                  <h3 className="text-white text-lg font-heading font-bold">{comic.title}</h3>
                  <p className="text-white/60 text-xs">{comic.author} &middot; {comic.chapters}话</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}